// The module's empty state, shared by state.js, the reset mutation and the status poll.
export const companyAlertsDefaults = () => ({
  list: {},
  profileMessagesCount: 0,
  unreadCount: 0,
  newLeadsCount: 0,
  taskCounts: {
    total: null,
    due: null,
  },
  unreadChatsCount: 0,
  statusPollFailing: false,
});

export const resetCompanyAlerts = (state) => Object.assign(state, companyAlertsDefaults());
